export default __webpack_public_path__ + "static/media/womenDress.a52141ba.svg";